export default "__VITE_ASSET__DBfHN6Vu__"